<template>
  <div>
    <!-- Sign In Modal -->
    <div v-if="dialogs.signin.isOpen" class="modal-backdrop fade show" @click="closeDialog('signin')"></div>
      
    <div class="modal" :class="{ 'fade': true, 'show': dialogs.signin.isOpen }" 
         :style="{ display: dialogs.signin.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="signinModalLabel" 
         :aria-hidden="!dialogs.signin.isOpen"
         @click.self="closeDialog('signin')">
      
      
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="signinModalLabel">{{ $t('signinModal.title') }}</h5>
            <button type="button" class="btn-close" @click="closeDialog('signin')" aria-label="Close"></button>
          </div>
          <form @submit.prevent="signInAndClose">
            <div class="modal-body">
              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label">{{ $t('signinModal.emailLabel') }}</label>
                <input type="text" class="form-control" id="exampleInputEmail1" 
                       v-model="username" autocomplete="username" required>
                <div class="form-text">{{ $t('signinModal.noAccountText') }} 
                  <span><a :href="signupLink">{{ $t('signinModal.signUpLink') }}</a></span>
                </div>
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword1" class="form-label">{{ $t('signinModal.passwordLabel') }}</label>
                <input type="password" class="form-control" id="exampleInputPassword1" 
                       v-model="password" autocomplete="current-password" required>
                <div class="form-text">
                  <span><a :href="changePasswordLink">{{ $t('signinModal.resetPasswordLink') }}</a></span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeDialog('signin')">
                {{ $t('signinModal.closeButton') }}
              </button>
              <button type="submit" class="btn btn-primary">
                {{ $t('signinModal.signInButton') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    
    <div v-if="dialogs.signout.isOpen" class="modal-backdrop fade show" @click="closeDialog('signout')"></div>
      
    <!-- Sign Out Modal -->
    <div class="modal" :class="{ 'fade': true, 'show': dialogs.signout.isOpen }" 
         :style="{ display: dialogs.signout.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="signoutModalLabel" 
         :aria-hidden="!dialogs.signout.isOpen"
         @click.self="closeDialog('signout')">
      
      
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="signoutModalLabel">{{ $t('signoutModal.title') }}</h5>
            <button type="button" class="btn-close" @click="closeDialog('signout')" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-text">{{ $t('signoutModal.confirmText') }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDialog('signout')">
              {{ $t('signoutModal.cancelButton') }}
            </button>
            <button type="button" class="btn btn-primary" @click="signOutAndClose">
              {{ $t('signoutModal.signOutButton') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="dialogs.error.isOpen" class="modal-backdrop fade show" @click="closeDialog('error')"></div>
    <!-- Error Modal -->
    <div class="modal" :class="{ 'fade': true, 'show': dialogs.error.isOpen }" 
         :style="{ display: dialogs.error.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="errorModalLabel1" 
         :aria-hidden="!dialogs.error.isOpen"
         @click.self="closeDialog('error')">
      
     
      
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="errorModalLabel1">{{ dialogs.error.title }}</h5>
            <button type="button" class="btn-close" @click="closeDialog('error')" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="form-text">{{ dialogs.error.details }}</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDialog('error')">
              {{ $t('errorModal.closeButton') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    
    <!-- Cookie Modal -->
    <div v-if="dialogs.cookie.isOpen" class="modal-backdrop fade show" @click="closeDialog('cookie')"></div>
    <div class="modal" :class="{ 'fade': true, 'show': dialogs.cookie.isOpen }" 
         :style="{ display: dialogs.cookie.isOpen ? 'block' : 'none' }" 
         tabindex="-1" 
         aria-labelledby="cookieModalLabel" 
         :aria-hidden="!dialogs.cookie.isOpen">
      
      
      
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="cookieModalLabel">{{ $t('cookieModal.title') }}</h5>
          </div>
          <div class="modal-body">
            <div class="form-text">
              <p>{{ $t('cookieModal.description') }}</p>
              <p>
                {{ $t('cookieModal.policyText') }}
                <a target="_blank" :href="privacyLink">{{ $t('cookieModal.policyLink') }}</a>.
              </p>
            </div>
            <div class="row">
              <a :href="cookiesLink" class="btn btn-sm btn-secondary col-lg-3">
                {{ $t('cookieModal.customizeButton') }}
              </a>
              <div class="d-none d-lg-block col-lg-3">&nbsp;</div>
              <button type="button" class="btn btn-sm btn-primary col-lg-3" 
                      @click="acceptAllCookiesAndClose">
                {{ $t('cookieModal.acceptButton') }}
              </button>
              <button type="button" class="btn btn-sm btn-secondary col-lg-3" 
                      @click="rejectOptionalCookiesAndClose">
                {{ $t('cookieModal.rejectButton') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18Utils } from "@/visualcrossing-core/i18utils";
import "/src/website-core/vccommunicatorloader.js";
import { VcLocationsStorage } from "/src/visualcrossing-core/vclocationsstorage";
import dialogManager from '@/utils/DialogManager.js';
import translations from '@/translations/signinsignout.js';

export default {
  i18n: {
    messages: translations,
  },
  name: 'SignInSignOut',
  props: {
    msg: String,
  },
  data() {
    return {
      username: null,
      password: null,
      sessionId: null,
      cookiesLink: "/cookies/",
      
      // Dialog state management
      dialogs: {
        signin: { isOpen: false },
        signout: { isOpen: false },
        error: { isOpen: false, title: '', details: '' },
        cookie: { isOpen: false }
      }
    };
  },
  methods: {
    // Dialog management methods
    openDialog(dialogName, options = {}) {
      if (dialogName === 'error') {
        this.dialogs.error.title = options.title || '';
        this.dialogs.error.details = options.details || '';
      }
      this.dialogs[dialogName].isOpen = true;
    },

    closeDialog(dialogName) {
      this.password = null; // Clear password on any dialog close
      this.dialogs[dialogName].isOpen = false;
      
      // Clear error details when closing error modal
      if (dialogName === 'error') {
        this.dialogs.error.title = '';
        this.dialogs.error.details = '';
      }
    },

    closeAllDialogs() {
       this.password = null; // Clear password on any dialog close
      Object.keys(this.dialogs).forEach(key => {
        this.dialogs[key].isOpen = false;
      });
    },

    // Handle ESC key
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        // Find and close the first open dialog
        const openDialog = Object.keys(this.dialogs).find(key => this.dialogs[key].isOpen);
        if (openDialog && openDialog !== 'cookie') { // Don't allow ESC to close cookie modal
          this.closeDialog(openDialog);
        }
      }
    },

    // Updated action methods
    signInAndClose() {
      this.signIn();
      this.closeDialog('signin');
    },

    signOutAndClose() {
      this.signOut();
      this.closeDialog('signout');
    },

    acceptAllCookiesAndClose() {
      this.acceptAllCookies();
      this.closeDialog('cookie');
    },

    rejectOptionalCookiesAndClose() {
      this.rejectOptionalCookies();
      this.closeDialog('cookie');
    },

    // Your existing methods (updated to use new dialog system)
    showError(title, details) {
      this.openDialog('error', { title, details });
    },

    showCookieConfirmation() {
      if (VcLocationsStorage.getValue("hasSetCookies") || window['vc-nocookieprompt']) return;
      this.openDialog('cookie');
    },

    acceptAllCookies() {
      VcLocationsStorage.enableAllCookies();
    },

    rejectOptionalCookies() {
      VcLocationsStorage.disableAllCookies();
    },

    setVcToolbarState() {
       const root = document.documentElement; // or a header/container element
      root.classList.toggle('has-session', !!this.hasSession);
      root.classList.toggle('no-session', !this.hasSession);
      // Optional a11y:
      //document.querySelector('.session')?.setAttribute('aria-hidden', (!this.hasSession).toString());
      //document.querySelector('.nosession')?.setAttribute('aria-hidden', (this.hasSession).toString());
      /*
      // Get ALL matching elements, not just the first one
      const sessionMenus = document.querySelectorAll(".vctoolbarbutton.session");
      const nosessionMenus = document.querySelectorAll(".vctoolbarbutton.nosession");
      
      if (sessionMenus.length === 0 || nosessionMenus.length === 0) {
        console.warn("Session or no-session menu elements not found. Found:", {
          sessionMenus: sessionMenus.length,
          nosessionMenus: nosessionMenus.length
        });
        // Don't return early - still process what we found
      }

      if (this.hasSession) {
        // Show all session menus
        sessionMenus.forEach(menu => {
          menu.style.display = "flex";
        });
        // Hide all no-session menus
        nosessionMenus.forEach(menu => {
          menu.style.display = "none";
        });
      } else {
        // Hide all session menus
        sessionMenus.forEach(menu => {
          menu.style.display = "none";
        });
        // Show all no-session menus
        nosessionMenus.forEach(menu => {
          menu.style.display = "flex";
        });
      }

      console.log(`Updated toolbar state: ${this.hasSession ? 'signed in' : 'signed out'}`, {
        sessionMenusUpdated: sessionMenus.length,
        nosessionMenusUpdated: nosessionMenus.length
      });
      */
    },

    signIn() {
      let me = this;
      vcCommunicator.createsession(this.username, this.password)
        .then(() => {
          console.log("Successful login");
          this.sessionId = vcCommunicator.sessionId;
        })
        .catch((error) => {
          console.log("Failed login");
          this.sessionId = null;
          this.showError(
            me.$t('errorModal.signInErrorTitle'),
            error || me.$t('errorModal.unknownError')
          );
        });
      this.password = null;
    },

    signOut() {
      vcCommunicator.signOut()
        .then(() => {
          this.sessionId = vcCommunicator.sessionId;
        })
        .catch((error) => {
          console.log("Sign out failed:", error);
          this.sessionId = null;
        });
    },
  },

  computed: {
    // ... your existing computed properties stay the same
    privacyLink() {
      return i18Utils.link("privacy");
    },
    usageLink() {
      return i18Utils.link("usage");
    },
    accountLink() {
      return i18Utils.link("account");
    },
    signupLink() {
      return i18Utils.link("sign-up");
    },
    changePasswordLink() {
      return i18Utils.link("change-password");
    },
    hasSession() {
      return this.sessionId;
    },
  },

  mounted() {
    // Register with global dialog manager
    dialogManager.registerComponent(this);
    
    // Add ESC key listener
    document.addEventListener('keydown', this.handleKeyDown);

    // ... your existing mounted code stays the same
    console.log("Mounting SigninSignout");
    document.querySelectorAll("a[data-vc-action='open-account']").forEach(anchor => {
      anchor.addEventListener("click", function(event) {
        event.preventDefault();
        i18Utils.redirectTo("account");
      });
    });
    
    document.querySelectorAll("a[data-vc-action='sign-up']").forEach(anchor => {
      anchor.addEventListener("click", function(event) {
        event.preventDefault();
        i18Utils.redirectTo("sign-up");
      });
    });

    const vcCommunicator = window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    
    this.sessionId = vcCommunicator.sessionId;
    vcCommunicator.addHandler('createsession', (sessionId) => {
      this.sessionId = sessionId;
      this.setVcToolbarState();
    });
    vcCommunicator.addHandler('terminatesession', () => {
      this.sessionId = null;
      this.setVcToolbarState();
    });

    setTimeout(() => {
      this.showCookieConfirmation();
    }, 500);

    this.setVcToolbarState();
  },

  beforeUnmount() {
    // Unregister from global dialog manager
    dialogManager.unregisterComponent();
    
    // Clean up event listener
    document.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>

<style scoped>
/* Modal styles to ensure proper display without Bootstrap JS */
/*
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1055;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal.show {
  display: block !important;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-dialog {
  position: relative;
  z-index: 1060;
}
  */
</style>
